import { VDBIcons } from "@utils/VDBIcons";
import { useTheme } from "styled-components/native";
import { SearchResultsAndFavoritesEnum } from "./searchResultConstants";

enum ShareMenuOptionEnum {
  SINGLE = "single",
  MULTIPLE = "multiple",
}

const ChangeViewMenuOptions = (t: any, enableMobileWebView?: boolean) => {
  const theme = useTheme();
  return [
    {
      name: SearchResultsAndFavoritesEnum.GRID,
      label: t("searchResult.changeViewOptions.gridView.text"),
      icon: SearchResultsAndFavoritesEnum.GRID,
    },
    {
      name: SearchResultsAndFavoritesEnum.LIST,
      label: t("searchResult.changeViewOptions.listView.text"),
      icon: SearchResultsAndFavoritesEnum.LIST,
    },
    theme?.isMobile &&
      !enableMobileWebView && {
        name: SearchResultsAndFavoritesEnum.LIST_EXPANDED,
        label: t("searchResult.changeViewOptions.listViewExpanded.text"),
        icon: VDBIcons.LIST_EXPANDED,
      },
  ].filter(Boolean);
};

const GemstoneChangeViewMenuOptions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.GRID,
      label: t("searchResult.changeViewOptions.gridView.text"),
      icon: SearchResultsAndFavoritesEnum.GRID,
    },
    {
      name: SearchResultsAndFavoritesEnum.LIST,
      label: t("searchResult.changeViewOptions.listView.text"),
      icon: SearchResultsAndFavoritesEnum.LIST,
    },
  ];
};

const allMenuOptions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.VIEW_DETAILS,
      label: t("searchResult.threeDotOptions.viewDetails.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_EMAIL,
      label: t("searchResult.threeDotOptions.share.email.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_NATIVE,
      label: t("searchResult.threeDotOptions.share.native.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.ADD_TO_FAVORITES,
      label: t("searchResult.threeDotOptions.addToFavorites.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST,
      label: t("global.addToBulkRequest.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST,
      label: t("global.removeFromBulkRequest.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.REMOVE_FROM_FAVORITES,
      label: t("searchResult.threeDotOptions.removeFromFavorites.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.ADD_TO_COLLECTION,
      label: t("searchResult.threeDotOptions.addToCollection.text"),
    },
  ];
};

const MenuItemOptions = (
  t: any,
  isFavorite: boolean,
  showBulkRequest: boolean,
  inCart: boolean,
  menuOptions: any
) => {
  if (menuOptions === null) {
    menuOptions = allMenuOptions(t);
  }
  const filteredOptions = menuOptions.filter((option) => {
    const isExcludingFavorites = isFavorite
      ? option.name !== SearchResultsAndFavoritesEnum.ADD_TO_FAVORITES
      : option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_FAVORITES;

    const isExcludingBulkRequest = showBulkRequest
      ? inCart
        ? option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST
        : option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST
      : option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST &&
        option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST;

    return isExcludingFavorites && isExcludingBulkRequest;
  });
  return filteredOptions;
};

const jewelryInitialProductArray = (t: any) => [
  {
    id: 1,
    title: t("searchResult.screenOptions.saveSearch.text"),
    description: "Description for Save Search",
    icon: VDBIcons.ADD_SAVED,
    eventName: SearchResultsAndFavoritesEnum.SAVE_SEARCH,
    selection: false,
  },
  {
    id: 2,
    title: t("searchResult.screenOptions.filters.text"),
    description: "Description for Filters",
    icon: VDBIcons.FILTER,
    eventName: SearchResultsAndFavoritesEnum.FILTERS,
    selection: false,
  },
  {
    id: 3,
    title: t("searchResult.screenOptions.sorting.text"),
    description: "Description for Sorting",
    icon: VDBIcons.SORT,
    eventName: SearchResultsAndFavoritesEnum.SORTING,
    selection: false,
  },
];

const initialProductArray = (t: any) => [
  {
    id: 1,
    title: t("searchResult.screenOptions.changeView.text"),
    description: "Description for Change View",
    icon: SearchResultsAndFavoritesEnum.GRID,
    eventName: SearchResultsAndFavoritesEnum.CHANGE_VIEW,
    selection: false,
  },
  {
    id: 2,
    title: t("searchResult.screenOptions.saveSearch.text"),
    description: "Description for Save Search",
    icon: VDBIcons.ADD_SAVED,
    eventName: SearchResultsAndFavoritesEnum.SAVE_SEARCH,
    selection: false,
  },
  {
    id: 3,
    title: t("searchResult.screenOptions.filters.text"),
    description: "Description for Filters",
    icon: VDBIcons.FILTER,
    eventName: SearchResultsAndFavoritesEnum.FILTERS,
    selection: false,
  },
  {
    id: 4,
    title: t("searchResult.screenOptions.sorting.text"),
    description: "Description for Sorting",
    icon: VDBIcons.SORT,
    eventName: SearchResultsAndFavoritesEnum.SORTING,
    selection: false,
  },
];

const initialProductArrayWeb = (t: any) => [
  {
    id: 1,
    title: t("searchResult.web.screenOptions.filters.text"),
    description: "Description for Filters",
    icon: "filter",
    eventName: SearchResultsAndFavoritesEnum.FILTERS,
    selection: false,
  },
  {
    id: 2,
    title: t("searchResult.web.screenOptions.saveSearch.text"),
    description: "Description for Save Search",
    icon: "add-saved",
    eventName: SearchResultsAndFavoritesEnum.SAVE_SEARCH,
    selection: false,
  },
  {
    id: 3,
    title: t("searchResult.web.screenOptions.changeView.text"),
    description: "Description for Change View",
    icon: SearchResultsAndFavoritesEnum.GRID,
    eventName: SearchResultsAndFavoritesEnum.CHANGE_VIEW,
    selection: false,
  },
  {
    id: 4,
    title: t("searchResult.web.screenOptions.sorting.text"),
    description: "Description for Sorting",
    icon: "sort",
    eventName: SearchResultsAndFavoritesEnum.SORTING,
    selection: false,
  },
  {
    id: 5,
    title: t("searchResult.web.screenOptions.columnCustomization.text"),
    description: "Description for Column Customization",
    icon: "sort",
    eventName: SearchResultsAndFavoritesEnum.CUSTOM_COLUMN,
    selection: false,
  },
  {
    id: 6,
    title: t("searchResult.bulkActions.button.text"),
    description: "Description for Bulk action",
    icon: "add-circle",
    eventName: SearchResultsAndFavoritesEnum.BULK_ACTION,
    selection: false,
  },
];

const jewelryInitialProductArrayWeb = (t: any) => [
  {
    id: 1,
    title: t("searchResult.web.screenOptions.filters.text"),
    description: "Description for Filters",
    icon: "filter",
    eventName: SearchResultsAndFavoritesEnum.FILTERS,
    selection: false,
  },
  {
    id: 2,
    title: t("searchResult.web.screenOptions.saveSearch.text"),
    description: "Description for Save Search",
    icon: "add-saved",
    eventName: SearchResultsAndFavoritesEnum.SAVE_SEARCH,
    selection: false,
  },
  {
    id: 3,
    title: t("searchResult.web.screenOptions.sorting.text"),
    description: "Description for Sorting",
    icon: "sort",
    eventName: SearchResultsAndFavoritesEnum.SORTING,
    selection: false,
  },
  {
    id: 4,
    title: t("searchResult.bulkActions.button.text"),
    description: "Description for Bulk action",
    icon: "add-circle",
    eventName: SearchResultsAndFavoritesEnum.BULK_ACTION,
    selection: false,
  },
];

const BulkActions = (t: any, showBulkRequest?: boolean) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.SHARE_EMAIL,
      label: t("searchResult.bulkActions.share.email.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_NATIVE,
      label: t("searchResult.bulkActions.share.native.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.ADD_TO_BULK_LIST,
      label: t("searchResult.bulkActions.addToBulkList.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.ADD_TO_FAVORITES,
      label: t("searchResult.bulkActions.addToFavorites.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.ADD_TO_COLLECTION,
      label: t("searchResult.bulkActions.addToCollection.text"),
    },
  ].filter(
    (action) =>
      showBulkRequest ||
      action.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_LIST
  );
};

const BulkTasks = (
  t: any,
  actionsData: any,
  showBulkRequest?: boolean,
  isMyInventory?: boolean
) => {
  if (!Array.isArray(actionsData)) {
    console.error("actionsData is not an array", actionsData);
    return [];
  }

  return actionsData
    .map((action) => ({
      name: action.name,
      label: t(action.label),
      description: t(action?.description),
    }))
    .filter((action) => {
      if (
        !showBulkRequest &&
        action.name === SearchResultsAndFavoritesEnum.ADD_TO_BULK_LIST
      ) {
        return false;
      }

      if (
        isMyInventory &&
        (action.name === SearchResultsAndFavoritesEnum.REQUEST_ITEMS ||
          action.name === SearchResultsAndFavoritesEnum.ADD_TO_BULK_LIST)
      ) {
        return false;
      }
      return true;
    });
};

export {
  ShareMenuOptionEnum,
  ChangeViewMenuOptions,
  GemstoneChangeViewMenuOptions,
  allMenuOptions,
  MenuItemOptions,
  jewelryInitialProductArray,
  initialProductArray,
  initialProductArrayWeb,
  jewelryInitialProductArrayWeb,
  BulkActions,
  BulkTasks,
};
